export default __webpack_public_path__ + "./images/genre.3dd47324.svg";